import { render, staticRenderFns } from "./addTax.vue?vue&type=template&id=2e9c8422&"
import script from "./addTax.vue?vue&type=script&lang=js&"
export * from "./addTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports